// ============================================================
// Button — Square Code button
//
// Variants: primary | secondary | ghost | danger
// Sizes:    sm | md | lg
// All are inline-styled to honor the OLIVIUM tokens.
// ============================================================

import { forwardRef } from 'react'

const VARIANT_STYLES = {
  primary: {
    background: 'var(--olv-grad-brand)',
    border: '1px solid rgba(124,92,252,0.40)',
    color: 'white',
    boxShadow: '0 1px 0 rgba(255,255,255,0.10) inset, 0 2px 12px rgba(124,92,252,0.20)',
  },
  secondary: {
    background: 'rgba(124,92,252,0.08)',
    border: '1px solid rgba(124,92,252,0.24)',
    color: 'var(--olv-purple)',
    boxShadow: 'none',
  },
  ghost: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.08)',
    color: 'var(--olv-text-secondary)',
    boxShadow: 'none',
  },
  danger: {
    background: 'rgba(255,59,92,0.10)',
    border: '1px solid rgba(255,59,92,0.30)',
    color: 'var(--olv-red)',
    boxShadow: 'none',
  },
}

const SIZE_STYLES = {
  sm: { padding: '5px 12px',  fontSize: 11 },
  md: { padding: '8px 16px',  fontSize: 12 },
  lg: { padding: '11px 22px', fontSize: 13 },
}

const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    type = 'button',
    disabled = false,
    loading = false,
    icon = null,
    children,
    style: styleOverride,
    ...rest
  },
  ref
) {
  const v = VARIANT_STYLES[variant] || VARIANT_STYLES.primary
  const s = SIZE_STYLES[size] || SIZE_STYLES.md
  const isInert = disabled || loading

  return (
    <button
      ref={ref}
      type={type}
      disabled={isInert}
      style={{
        ...v,
        ...s,
        borderRadius: 'var(--olv-radius-card)',
        fontFamily: 'var(--font-mono)',
        letterSpacing: '0.04em',
        cursor: isInert ? 'not-allowed' : 'pointer',
        opacity: isInert ? 0.55 : 1,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        transition: 'transform 200ms var(--ease-standard), opacity 200ms var(--ease-standard)',
        ...styleOverride,
      }}
      {...rest}
    >
      {loading && (
        <span
          aria-hidden
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            border: '1.5px solid currentColor',
            borderTopColor: 'transparent',
            animation: 'olv-spin 600ms linear infinite',
          }}
        />
      )}
      {icon && !loading && <span style={{ display: 'inline-flex' }}>{icon}</span>}
      {children}
    </button>
  )
})

export default Button
